import currentDriverTypes from "./currentDriver.types";

const INITIAL_STATE = {
  info: "",

  isLoading: false,
};

const currentDriverReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case currentDriverTypes.FETCH_CURRENTDRIVER_START:
      return {
        ...state,
        isLoading: true,
      };
    case currentDriverTypes.FETCH_CURRENTDRIVER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        info: action.payload,
      };

    default:
      return state;
  }
};

export default currentDriverReducer;
